import { IGridConfig } from "./GridView.config";

export { IGridConfig } from "./GridView.config";

export class GridView {
    private GetColumnsForScaffolding = (data) => {
        if (typeof data.length !== 'number' || data.length === 0) {
            return [];
        }
        var Columns = [];
        for (var propertyName in data[0]) {
            Columns.push({ headerText: propertyName, rowText: propertyName });
        }
        return Columns;
    }

    private pickColumns = (row, columns) => {

        if (!row || !columns)
            return;

        return columns.map(k => k in row ? { [k]: row[k] } : {})
            .reduce((res, o) => Object.assign(res, o), {});
    }

    private escapeRegExp = (str) => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }


    private convertWildcardStringToRegExp = (expression) => {

        if (!expression)
            return;

        var terms = expression.split('*');

        var trailingWildcard = false;

        var expr = '';
        for (var i = 0; i < terms.length; i++) {

            if (terms[i]) {
                if (i > 0 && terms[i - 1]) {
                    expr += '\\S*';
                }
                trailingWildcard = false;
                expr += this.escapeRegExp(terms[i]);
            } else {
                trailingWildcard = true;
                //end of expression
                expr += '\\S*';
            }
        }

        if (!trailingWildcard) {
            //end of expression
            expr += '\\S*';
        }

        let result = new RegExp('\\S*' + expr, 'ig');
        return result;
    }
    
    // Spare Multipurpose Observables and Functions
    // TODO: Move away from these functions as we can now scope and attach to the running VM without this workaround
    ObservableOne: KnockoutObservable<any>;
    ObservableTwo: KnockoutObservable<any>;
    ObservableThree: KnockoutObservable<any>;
    ObservableArrayOne: KnockoutObservableArray<any>;
    ObservableArrayTwo: KnockoutObservableArray<any>;
    Computed0: KnockoutComputed<any>;
    Computed1: KnockoutComputed<any>;
    Computed2: KnockoutComputed<any>;
    ClickFnOne: (param: any | any[]) => void;
    ClickFnTwo: (params: any | any[]) => void;
    ClickFnThree: (params: any | any[]) => void;

    UseFilter: boolean;
    WildCardFilter: boolean;
    Filter: KnockoutObservable<any>;
    FilterCriteria: Array<string>;
    SectionFilter: boolean;
    SectionKey: string;
    SectionValue: KnockoutObservable<string>;

    RawData: KnockoutObservableArray<any>;
    Data: KnockoutComputed<any>;
    DataLoaded: KnockoutObservable<boolean> = ko.observable(false);
    CurrentPageIndex: KnockoutObservable<number>;
    Columns: KnockoutComputed<any>;
    ItemsOnCurrentPage: KnockoutComputed<any>;    
    PageSize: KnockoutObservable<number> = ko.observable(30);

    PageIndex: KnockoutComputed<number>;
    MaxPageIndex: KnockoutComputed<number>;
    PreviousPage;
    NextPage;

    GridName: string;
    LastSectionVal: string;

    constructor(configuration: IGridConfig) {
        var self = this;

        self.GridName = configuration.GridTemplateName || "Grid-" + Math.floor(Math.random() * 100);
        self.UseFilter = configuration.UseFilter || false;
        self.WildCardFilter = configuration.WildCardFilter || false;
        self.SectionFilter = configuration.SectionFilter || false;
        self.SectionKey = configuration.SectionKey || null;
        self.SectionValue = configuration.SectionValue || ko.observable(null);
        self.LastSectionVal = self.SectionValue() || null;
        self.RawData = configuration.Data;
        
        if (self.UseFilter) {

            let filteredResults = [];

            function regexMatchRowJSON(rowJSON) {

                let stringToSearch = rowJSON.join(' ');

                let results = false;

                if (!self.Filter())
                    return;

                let testValue = self.convertWildcardStringToRegExp(self.Filter()).test(stringToSearch);

                if (testValue) {
                    results = true;
                }

                return results;
            }

            function filterRowData(row) {
                if (!self.WildCardFilter) {

                    self.FilterCriteria.forEach(function (filter) {

                        // Check if the row is already in the array, if yes then skip this iteration
                        for (var i = 0; i < filteredResults.length; i++) {
                            if (filteredResults[i] === row) return;
                        }

                        if (filter) {
                            if (row[filter] && self.Filter())
                                if (row[filter].toString().toLowerCase().includes(self.Filter().toString().toLowerCase()))
                                    filteredResults.push(row);
                        }
                    });

                }

                if (self.WildCardFilter) {

                    //let pickedRowValuesOld = Object['values'](pickColumns(row, self.FilterCriteria))
                    //    .filter(function (e) { return e });

                    let criteria = self.pickColumns(row, self.FilterCriteria);
                    let pickedRowValues = Object.keys(criteria).map(function (key) {
                        return criteria[key]
                    }).filter(function (e) { return e; });

                    void (pickedRowValues !== null
                        && regexMatchRowJSON(pickedRowValues)
                        && filteredResults.push(row));
                }

            }

            self.Filter = ko.observable("").extend({ rateLimit: { timeout: 500, method: "notifyWhenChangesStop" } });

            self.Filter.subscribe(function (change) {
                if (change) {
                    self.CurrentPageIndex(0);
                }
            })

            self.FilterCriteria = configuration.FilterCriteria;

            self.Data = ko.pureComputed({

                read: function () {

                    if (!self.RawData())
                        return;
                    let originalArray = self.RawData().slice();

                    function runFilter(array) {
                        filteredResults = [];
                        if (self.Filter() === "") {
                            self.Filter(null);
                            self.CurrentPageIndex(0);
                            return array;
                        }

                        if (array) {
                            // Pass raw data if no filter value
                            if (self.Filter() === "" || self.Filter() === null)
                                return array;

                            array.filter(function (row) {

                                if (self.FilterCriteria.length > 0)
                                    filterRowData(row);

                            });
                        }
                        return filteredResults;
                    }

                    if (self.SectionFilter) {
                        if (self.SectionValue() !== self.LastSectionVal) {
                            self.CurrentPageIndex(0);
                            self.LastSectionVal = self.SectionValue();
                        }

                        if (self.SectionValue()) {
                            if (self.SectionValue() == self.LastSectionVal) {
                                self.CurrentPageIndex();
                                self.LastSectionVal = self.SectionValue();
                            }

                            let newArray = []
                            if (originalArray.length > 0) {
                                originalArray.forEach(function (row, index) {
                                    if (row[self.SectionKey].toString() === self.SectionValue().toString()) {
                                        newArray.push(row);
                                    }
                                })
                            }
                            return runFilter(newArray);

                        }
                        return runFilter(self.RawData());

                    } else {
                        self.CurrentPageIndex(0);
                        return runFilter(self.RawData());
                    }
                },

                // For sorting to feed the data back to the source object
                write: function (value) {
                    self.RawData(value);
                },
                owner: self
            });
        }
        else {
            self.Data = ko.pureComputed({
                read: function () {
                    return self.RawData();
                },
                write: function (value) {
                    self.RawData(value);
                },
                owner: self
            });
        }
        
        self.CurrentPageIndex = ko.observable(0);
        if (configuration.PageSize)
            self.PageSize(parseInt(configuration.PageSize.toString()));
        else {
            self.PageSize(5);
        }


        // If you don't specify columns configuration, we'll use scaffolding
        self.Columns = ko.pureComputed(
            function () {
                if (typeof configuration.Columns == 'undefined') {
                    return self.GetColumnsForScaffolding(ko.unwrap(self.RawData));

                }
                else {
                    return configuration.Columns;
                }
            }
        );
        
        self.ItemsOnCurrentPage = ko.computed(function () {            
            let startIndex = parseInt(self.PageSize().toString()) * self.CurrentPageIndex();
            let endIndex = startIndex + parseInt(self.PageSize().toString());
            let result = ko.unwrap(self.Data()).slice(startIndex, endIndex);
            return result;

        }, self);

        self.PageIndex = ko.pureComputed({
            read: function () {
                return self.CurrentPageIndex() + 1
            },

            write: function (value: number) {
                let page = value - 1;

                if (value > 0)
                    self.CurrentPageIndex(page);
            },

            owner: self
        });

        self.MaxPageIndex = ko.computed(function () {
            return Math.ceil(ko.unwrap(self.Data()).length / self.PageSize()) - 1;
        }, self);

        self.PreviousPage = function () {
            if (self.CurrentPageIndex() > 0) {
                self.CurrentPageIndex(self.CurrentPageIndex() - 1);
            }
        };

        self.NextPage = function () {
            if (self.CurrentPageIndex() < self.MaxPageIndex()) {
                self.CurrentPageIndex(self.CurrentPageIndex() + 1);
            }
        };


        // The "simpleGrid" binding
        ko.bindingHandlers.simpleGrid = {
            init: function () {
                return { 'controlsDescendantBindings': true };
            },
            // This method is called to initialize the node, and will also be called again if you change what the grid is bound to
            update: function (element, viewModelAccessor, allBindings) {

                // Templates used to render the grid
                var templateEngine = new ko.nativeTemplateEngine();

                var addTemplate = function (templateName, templateMarkup) {
                    document.write("<script type='text/html' id='" + templateName + "'>" + templateMarkup + "<" + "/script>");
                };

                //    addTemplate("ko_simpleGrid_grid", "\
                //<table class=\"ko-grid\" cellspacing=\"0\">\
                //    <thead>\
                //        <tr data-bind=\"foreach: columns\">\
                //           <th data-bind=\"text: headerText\"></th>\
                //        </tr>\
                //    </thead>\
                //    <tbody data-bind=\"foreach: itemsOnCurrentPage\">\
                //       <tr data-bind=\"foreach: $parent.columns\">\
                //           <td data-bind=\"text: typeof rowText == 'function' ? rowText($parent) : $parent[rowText] \"></td>\
                //        </tr>\
                //    </tbody>\
                //</table>");
                //    addTemplate("ko_simpleGrid_pageLinks", "\
                //<div class=\"ko-grid-pageLinks\">\
                //    <span>Page:</span>\
                //    <!-- ko foreach: ko.utils.range(0, maxPageIndex) -->\
                //           <a href=\"#\" data-bind=\"text: $data + 1, click: function() { $root.currentPageIndex($data) }, css: { selected: $data == $root.currentPageIndex() }\">\
                //        </a>\
                //    <!-- /ko -->\
                //</div>");

                var viewModel = viewModelAccessor();

                // Empty the element
                while (element.firstChild)
                    ko.removeNode(element.firstChild);

                // Allow the default templates to be overridden
                var gridTemplateName = allBindings.get('simpleGridTemplate') || "ko_simpleGrid_grid",
                    pageLinksTemplateName = allBindings.get('simpleGridPagerTemplate') || "ko_simpleGrid_pageLinks";

                // Render the main grid
                var gridContainer = element.appendChild(document.createElement("DIV"));
                ko.renderTemplate(gridTemplateName, viewModel, { templateEngine: templateEngine }, gridContainer, "replaceNode");

                // Render the page links
                var pageLinksContainer = (configuration.PagerPos === "top") ?
                    element.insertBefore(document.createElement("DIV"), element.firstChild) :
                    element.appendChild(document.createElement("DIV"));

                ko.renderTemplate(pageLinksTemplateName, viewModel, { templateEngine: templateEngine }, pageLinksContainer, "replaceNode");
            }
        };

        // Highlight search terms
        ko.bindingHandlers.highlight = {
            update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
                let options = valueAccessor(),
                    value = ko.utils.unwrapObservable(options.text),
                    keyword = ko.utils.unwrapObservable(bindingContext['$root'].Filter()),
                    regex = !self.WildCardFilter ? new RegExp('\\S*((' + keyword + '))\\S*', 'ig') : self.convertWildcardStringToRegExp(keyword),
                    css = ko.utils.unwrapObservable(options.css);


                if (options.sanitize) {
                    value = $('<div/>').text(value).html();
                }

                if (!keyword || !value) // considered clearing the highlight, but this sticky highlighting of the last result is a nice feature                            
                    return;

                element.innerHTML = value.toString().replace(regex, '<span class="' + css + '">$&</span>');

            }
        };

        // Sort binding
        ko.bindingHandlers.sort = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var asc = false;
                element.style.cursor = 'pointer';

                element.onclick = function () {
                    var value = valueAccessor();
                    var prop = value.prop;
                    // This is the data source we bind on the front-end. It's the computed observable data source for the grid if filters are used.
                    var data = ko.unwrap(value.arr);

                    asc = !asc;

                    data.sort(function (left, right) {
                        var rec1 = left;
                        var rec2 = right;

                        if (!asc) {
                            rec1 = right;
                            rec2 = left;
                        }

                        var props = prop.split('.');
                        for (var i in props) {
                            var propName = props[i];
                            var parenIndex = propName.indexOf('()');
                            if (parenIndex > 0) {
                                propName = propName.substring(0, parenIndex);
                                rec1 = rec1[propName]();
                                rec2 = rec2[propName]();
                            } else {
                                rec1 = rec1[propName];
                                rec2 = rec2[propName];
                            }
                        }

                        return rec1 === rec2 ? 0 : rec1 < rec2 ? -1 : 1;
                    });

                    // We push the sorted data back into the computed observable
                    value.arr(data);
                };
            }
        };


        $(() => {
            $(document).ajaxComplete(() => { self.DataLoaded(true)})
        })
        
    }

}